import Cookie from 'js-cookie';
import { useEffect, useState } from 'react';

// The iOS App Store wrapper (tf-ios-pwa) natively sets the `app-platform`
// cookie on every launch. App Store rules don't allow selling subscriptions
// through Stripe inside the app, so all checkout and billing-portal entry
// points must not render there. Do NOT gate on the `isApp` cookie instead:
// the browser-installed PWA sets it too (start_url ?utm_source=pwa) and
// those users may purchase normally.
export const isIosApp = () =>
  typeof window !== 'undefined' && Boolean(Cookie.get('app-platform'));

export const useIsIosApp = () => {
  const [inIosApp, setInIosApp] = useState(false);

  useEffect(() => {
    setInIosApp(isIosApp());
  }, []);

  return inIosApp;
};
